import React, { useEffect, useState } from "react";
import styles from "./free.module.css";
import FormFields from "../../Form";
import "react-tabs/style/react-tabs.css";
import SaveButton from "components/SaveButton";
import IconButton from "common/IconButton";
import Toast from "utils";
import dayjs from "dayjs";

const FreeTicket = ({ data, ticket_id, ticketDetails, setticketDetails_ ,variant_type,onVariantSubmit,eventDetails}) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  useEffect(() => {
    if (data) {
      setticketDetails_({ ...data });
      setSelectedTabIndex(data?.ticket_type === "paid" ? 0 : 1);
    }
  }, [data]);

  const pathname = window.location.pathname;

  const handleAddVariant = (e) => {
    e.preventDefault();
    onVariantSubmit(e);
  };

  const handleDuplicateVariant = (e) => {
    e.preventDefault();
    onVariantSubmit(e, true);
  };
const freeTiket = true;

  const deriveTicketsSold = () => {
    if (!ticket_id) return 0;
    const initialSold = Number(ticketDetails?.initial_tickets_sold);
    if (!Number.isNaN(initialSold)) {
      return Math.max(0, initialSold);
    }
    const explicitSold = Number(ticketDetails?.tickets_sold);
    if (!Number.isNaN(explicitSold)) {
      return Math.max(0, explicitSold);
    }
    const oldTotal = Number(ticketDetails?.quantity_available) || 0;
    const oldCurrent = Number(ticketDetails?.current_quantity) || 0;
    return Math.max(0, oldTotal - oldCurrent);
  };

  const ticketsSold = deriveTicketsSold();
  const minimumQuantityAllowed = ticket_id ? Math.max(ticketsSold, 0) : 0;

  const handleChange = (label, parseType) => (e) => {
    let value = e.target ? e.target.value : e;

    if (parseType) {
      value = parseType(value);
      if (e?.target?.type === "checkbox") {
        value = parseType(e);
      }
    }

    if (label === "quantity_available") {
      const newQuantity = Number(e?.target?.value) || 0;

      if (ticket_id) {
        if (newQuantity < minimumQuantityAllowed) {
          Toast().Error(
            `Total quantity cannot be less than the tickets already sold (${minimumQuantityAllowed}).`
          );
          return setticketDetails_((prev) => ({
            ...prev,
            quantity_available: newQuantity,
          }));
        }

        const newCurrentQuantity = Math.max(0, newQuantity - ticketsSold);
        return setticketDetails_((prev) => ({
          ...prev,
          quantity_available: newQuantity,
          current_quantity: newCurrentQuantity,
        }));
      }

      return setticketDetails_((prev) => ({
        ...prev,
        quantity_available: newQuantity,
      }));
    }

    setticketDetails_((prev) => ({
      ...prev,
      [label]: value,
    }));
  };

  const options = [
    {
      value: 1,
      label: "Leanne Graham",
    },
    {
      value: 2,
      label: "Ervin Howell",
    },
  ];
  const startsDate = ticketDetails?.on_sale_from ? dayjs(ticketDetails.on_sale_from).toDate() : null;
  const endsMinDate = startsDate || new Date();
  const SecondFormFields = [
    // {
    //   label: "Currency Type",
    //   id: "currency_type",
    //   placeholder: "Currency Type",
    //   type: "select",
    //   value: ticketDetails?.currency_type,
    //   required: false,
    //   options:[{value:"GB", label:"GBP"}],
    //   onChange: handleChange("currency_type"),
    //   disabled: freeTiket === true,
    // },
    {
      label: null,
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      },
      children: [
        {
          label: "Price",
          id: "price",
          placeholder: "£ 0.00",
          min: 0,
          type: "number",
          value: ticketDetails?.price,
          required: false,
          options,
          onChange: handleChange("price", Number),
          disabled: freeTiket === true, 

        },
      ],
    },
    {
      label: null,
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      },
      children: [
        {
          label: "On Sale From",
          id: "on_sale_from",
          placeholder: "Pick Date",
          style: { width: "50%" },
          type: "dateTimePicker",
          formGroupStyleOverride: { flex: 1, marginRight: "20px" },
          selected: ticketDetails?.on_sale_from,
          // required: false,
          selectedHours: ticketDetails?.startHours,
          onHoursChange: handleChange("startHours"),
          selectedMinutes: ticketDetails?.startMinutes,
          onMinutesChange: handleChange("startMinutes"),
          required: true,
          onChange: handleChange("on_sale_from"),
          minDate: new Date(),

        },
        {
          label: "On Sale To",
          id: "on_sale_to",
          placeholder: "Pick Date",
          style: { width: "50%" },
          type: "dateTimePicker",
          formGroupStyleOverride: { flex: 1 },
          selected: ticketDetails?.on_sale_to,
          // maxDate: eventDetails?.event_name?.starts || "",
          required: false,
          onChange: handleChange("on_sale_to"),
          selectedHours: ticketDetails?.endHours,
          onHoursChange: handleChange("endHours"),
          selectedMinutes: ticketDetails?.endMinutes,
          onMinutesChange: handleChange("endMinutes"),
          minDate: endsMinDate, 

        },
      ],
    },
    {
      label: "Quantity Available",
      id: "quantity_available",
      placeholder: "Quantity Available",
      type: "number",
      value: ticketDetails?.quantity_available,
      min: 0,
      required: true,
      // options,
      onChange: handleChange("quantity_available"),
    },
    {
      label: "Order Limits",
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // width: "100%",
        flex: 1,
      },
      children: [
        {
          label: "Min Tickets Per Order",
          id: "min_tickets_per_order",
          placeholder: "100",
          type: "number",
          min: 0,
          width: "50%",
          value: ticketDetails?.min_tickets_per_order,
          formGroupStyleOverride: { flex: 1, marginRight: "20px" },
          required: false,
          options,
          onChange: handleChange("min_tickets_per_order", Number),
        },
        {
          label: "Max Tickets Per Order",
          id: "max_tickets_per_order",
          placeholder: "100",
          type: "number",
          min: 0,

          value: ticketDetails?.max_tickets_per_order,
          formGroupStyleOverride: { flex: 1 },
          required: false,
          options,
          onChange: handleChange("max_tickets_per_order", Number),
        },
      ],
    },
    {
      label: "Disable this ticket type",
      parentLabel: "Disable Ticket Type",
      id: "disable_ticket_type",
      name: "visbility",

      placeholder: "100",
      type: "checkbox",
      value: ticketDetails?.disable_ticket_type,
      required: false,
      options,
      onChange: handleChange("disable_ticket_type", Boolean),
    },

    {
      label: "Only Accessible via Rep Link",
      parentLabel: "Rep Only Ticket",
      id: "rep_only_ticket",
      name: "visbility",
      placeholder: "100",
      type: "checkbox",
      value: ticketDetails?.rep_only_ticket,
      required: false,
      options,
      onChange: handleChange("rep_only_ticket", Boolean),
    },

    {
      label: "Password Protected Ticket",
      parentLabel: "Password Protection",
      id: "is_password_protected",
      name: "is_password_protected",
      type: "checkbox",
      checked: ticketDetails?.is_password_protected ?? false,
      onChange: handleChange("is_password_protected", (e) => e?.target?.checked),
    },
    // Conditionally show password field when checkbox is checked
    ...(ticketDetails?.is_password_protected ? [{
      label: "Ticket Password",
      id: "password",
      placeholder: "Enter password for this ticket",
      type: "text",
      value: ticketDetails?.password || "",
      required: true,
      maxLength: 50,
      onChange: handleChange("password"),
    }] : []),

    {
      label: "SubTitle or Description",
      id: "subtitle_description",
      styles: { width: "100% !important" },
      placeholder: "A Brief Description",
      type: "text",
      formGroupStyleOverride: { maxWidth: "100%" },
      value: ticketDetails?.subtitle_description,
      required: false,
      options,
      onChange: handleChange("subtitle_description"),
    },
    // {
    //   parentLabel: "Ticket Image",
    //   label:
    //     "Events with images are noticed by more customers, and usually sell more tickets.",
    //   id: "eventImage",
    //   type: "image",
    //   value: ticketDetails?.eventImage,
    //   onChange: handleChange("eventImage"),
    // },
  ];

  const firstButtonArgs = {
    label: "Cancel",
    id: "cancelTicket",
    type: "button",
    buttonOverrideInlineStyle: { marginRight: "1.6rem" },
    onClick: () => {},
  };

  const secondButtonArgs = {
    label: ticket_id ? "Update" : "Create",
    id: "createTicket",
    type: "submit",
    onClick: () => {},
  };

  return (
    <>
      {SecondFormFields?.map((e) => {
        if (e?.children) {
          return (
            <>
              {e?.parentLabel && (
                <label
                  style={{
                    display: "block",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  {e?.parentLabel}
                </label>
              )}
              <div style={e?.style}>
                <FormFields Fields={e?.children} />
              </div>
            </>
          );
        }

        return (
          <>
            {e?.parentLabel && (
              <label
                style={{ display: "block", width: "100%", textAlign: "left" }}
              >
                {e?.parentLabel}
              </label>
            )}

            <FormFields Fields={[e]} />
          </>
        );
      })}

      {/* <SaveButton
        firstButtonArgs={firstButtonArgs}
        secondButtonArgs={secondButtonArgs}
      /> */}
       {variant_type === "variant" ? (
        <>
          {!pathname.startsWith("/ticket/edit-ticket") && (
            <div className={styles.variantButtonRow}>
              <IconButton
                // label={"Add Another Variant"}
                label={` ${
                  pathname === "/ticket/create-ticket"
                    ? "Add another Variant"
                    : " Add another Variant"
                }`}
                type="submit"
                icon="Add"
                buttonFunction={handleAddVariant}
              />
              <IconButton
                label=" Duplicate Variant"
                type="submit"
                icon="Add"
                buttonFunction={handleDuplicateVariant}
              />
            </div>
          )}

          <SaveButton
            firstButtonArgs={firstButtonArgs}
            secondButtonArgs={secondButtonArgs} />
        </>
      ) : (
        <SaveButton
          firstButtonArgs={firstButtonArgs}
          secondButtonArgs={secondButtonArgs}
        />
      )}
    </>
  );
};

export default FreeTicket;
